import React from "react";
import { object, array, string } from "prop-types";

import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";

import "./bredcrums.m.css";

const BredcrumHtml = ({ item, type, story }) => {
  let url = "";
  Number(item[item.length - 1]) && item.pop();

  const removeExtraString = (secname) => {
    let str = "";
    if (secname.includes("-")) {
      const sections = secname.split("-");
      sections.forEach((item) => (str += item + " "));
      str = str.charAt(0) + str.substring(1);
    } else {
      str = secname.charAt(0) + secname.substring(1);
    }
    return str;
  };

  return (
    <>
      {item.map((secname, i) => {
        const sectionName = removeExtraString(decodeURI(secname));
        if (item.length - 1 !== i) {
          url += `/${secname}`;
        }

        return (
          <>
            {item.length > 1 && item.length - 1 > i ? (
              <a key={i} href={url}>
                <span styleName="item">{sectionName}</span>
                <SvgIconHandler type="bredrightarrow" height="8px" width="8px" />
              </a>
            ) : (
              <>
                {/* <a key={i}>
                <span styleName="item last-item">{type === "story-page" ? story.headline : sectionName}</span>
              </a> */}
              </>
            )}
          </>
        );
      })}
    </>
  );
};

BredcrumHtml.propTypes = {
  item: array
};

const Bredcrum = ({ initialPath, type, story }) => {
  let path = "";
  const name = `bredcrum-${type}`;

  if (initialPath.includes("#")) {
    const lastIndex = initialPath.indexOf("#");
    path = initialPath.slice(1, lastIndex);
  } else {
    path = initialPath.slice(1, initialPath.length);
  }

  const section = path.split("/");

  return (
    <div styleName="wrapper">
      <a href="/">
        <span styleName="item">Home</span>
        <SvgIconHandler type="bredrightarrow" height="8px" width="8px" />
      </a>
      <BredcrumHtml item={section} story={story} type={type} />
    </div>
  );
};

Bredcrum.propTypes = {
  initialPath: string,
  type: string,
  story: object
};

export default Bredcrum;
